import { connect } from 'react-redux';
import { activeDirectoryAction, loginAction } from '../../actions/auth';
import { selectors as authSelectors } from '../../ducks/authDuck';
import Login from './Login';

const mapStateToProps = state => ({
  error: authSelectors.error(state),
  isLoading: authSelectors.isLoading(state),
  token: authSelectors.token(state),
});

const mapDispatchToProps = {
  login: loginAction,
  activeDirectory: activeDirectoryAction,
};

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);
export default LoginContainer;
